document.addEventListener("click", function (e) {
const question = e.target.closest('.faq-question');
if (question) {

  const item = question.closest('.faq-item');
  const answer = item.querySelector('.faq-answer');
  const icon = question.querySelector('.faq-icon');

  // Close others
  document.querySelectorAll('.faq-item').forEach(other => {
    if (other !== item) {
      other.classList.remove('active');
      const otherAnswer = other.querySelector('.faq-answer');
      const otherIcon = other.querySelector('.faq-icon');

      if (otherAnswer) {
        otherAnswer.style.maxHeight = null;
      }

      if (otherIcon) {
        otherIcon.textContent = '+';
      }
    }
  });

  // Toggle current
  item.classList.toggle('active');

  if (item.classList.contains('active')) {
    answer.style.maxHeight = answer.scrollHeight + 'px';
    icon.textContent = '−';
  } else {
    answer.style.maxHeight = null;
    icon.textContent = '+';
  }

  return; // <-- ADD THIS LINE
}
const viewMore = e.target.closest("#faqViewMore");

  if (viewMore) {
    document.querySelectorAll(".faq-item.faq-hidden").forEach(function(item) {
      item.classList.remove("faq-hidden");
    });

    viewMore.remove();
    return;
  }
});

// document.addEventListener("DOMContentLoaded", function () {

//   const viewMoreBtn = document.getElementById("faqViewMore");

//   console.log("Button:", viewMoreBtn);

//   if (!viewMoreBtn) return;

//   viewMoreBtn.onclick = function () {

//     console.log("Clicked");

//     document.querySelectorAll(".faq-item.faq-hidden").forEach(function(item){
//       item.classList.remove("faq-hidden");
//     });

//     this.remove();
//   };

// });